module.exports = __webpack_public_path__ + "static/media/illustrations.972cdab5.jpg";